/*
 * Click-to-play YouTube facade.
 *
 * The page ships a thumbnail and a play button; the iframe is only built when
 * someone actually clicks. That keeps YouTube's player - and its cookies - off
 * the page for visitors who never press play, and keeps the embed on
 * youtube-nocookie.com when they do.
 */
(function () {
  'use strict';

  function buildEmbedUrl(videoId, start) {
    var url =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    var seconds = parseInt(start, 10);
    if (seconds > 0) url += '&start=' + seconds;
    return url;
  }

  function play(frame) {
    if (frame.dataset.youtubeLoaded === 'true') return;
    frame.dataset.youtubeLoaded = 'true';

    var videoId = frame.getAttribute('data-video-id');
    if (!videoId) return;

    var iframe = document.createElement('iframe');
    iframe.className = 'listing-video__iframe';
    iframe.src = buildEmbedUrl(videoId, frame.getAttribute('data-start'));
    iframe.setAttribute('title', 'Featured episode');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');

    frame.innerHTML = '';
    frame.appendChild(iframe);
    /*
     * preventScroll, like every other focus call in this theme. The iframe is
     * built at the moment of the tap, so a plain focus() scrolls the player
     * into view and moves the page under the person who just pressed play.
     */
    iframe.focus({ preventScroll: true });
  }

  function initFrame(frame) {
    if (frame.dataset.youtubeBound === 'true') return;
    frame.dataset.youtubeBound = 'true';

    var trigger = frame.querySelector('[data-youtube-play]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        play(frame);
      });
    }

    // The inline onerror handles the usual case. This catches a maxres
    // thumbnail that already 404'd before this script parsed.
    var thumb = frame.querySelector('.listing-video__thumb');
    if (thumb && thumb.dataset.fallback) {
      if (thumb.complete && thumb.naturalWidth === 0) {
        thumb.src = thumb.dataset.fallback;
      }
    }
  }

  function init(scope) {
    var frames = (scope || document).querySelectorAll('[data-youtube-facade]');
    Array.prototype.forEach.call(frames, initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
